export const PAYMENT_WATCHDOG_SETTING_ID = "paymentWatchdogFollowUps";

export const PAYMENT_WATCHDOG_FOLLOW_UP_STATUSES = {
  TO_CONTACT: "TO_CONTACT",
  REMINDED: "REMINDED",
  WAITING_FOR_REPLY: "WAITING_FOR_REPLY",
  EXPLAINED: "EXPLAINED",
};

export const PAYMENT_WATCHDOG_FOLLOW_UP_STATUS_OPTIONS = [
  { value: PAYMENT_WATCHDOG_FOLLOW_UP_STATUSES.TO_CONTACT, text: "Do kontaktu" },
  { value: PAYMENT_WATCHDOG_FOLLOW_UP_STATUSES.REMINDED, text: "Przypomniano" },
  { value: PAYMENT_WATCHDOG_FOLLOW_UP_STATUSES.WAITING_FOR_REPLY, text: "Czeka na odpowiedz" },
  { value: PAYMENT_WATCHDOG_FOLLOW_UP_STATUSES.EXPLAINED, text: "Wyjasnione" },
];

export const PAYMENT_WATCHDOG_PRIORITY_LABELS = {
  HIGH: "Wysoki",
  MEDIUM: "Sredni",
  LOW: "Niski",
};

export const PAYMENT_WATCHDOG_PRIORITY_OPTIONS = [
  { value: "HIGH", text: PAYMENT_WATCHDOG_PRIORITY_LABELS.HIGH },
  { value: "MEDIUM", text: PAYMENT_WATCHDOG_PRIORITY_LABELS.MEDIUM },
  { value: "LOW", text: PAYMENT_WATCHDOG_PRIORITY_LABELS.LOW },
];

const DAY_IN_MS = 24 * 60 * 60 * 1000;

function padDatePart(value) {
  return String(value).padStart(2, "0");
}

function getUtcDateOnly(value) {
  const date = value instanceof Date ? value : new Date(value);
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}

function hasValue(value) {
  return value !== undefined && value !== null;
}

function getSettlementBalance(settlement) {
  if (hasValue(settlement.summaryClosingBalance)) return settlement.summaryClosingBalance;
  return settlement.closingBalance || 0;
}

function getSettlementMonth(settlement) {
  return settlement.month || settlement.settlementMonth;
}

function getPriority({ isDebtCase, amountDue, overdueDays, approved }) {
  if (!isDebtCase) return "";
  if (overdueDays >= 14 || amountDue >= 300) return "HIGH";
  if (overdueDays >= 1 || amountDue >= 100 || approved) return "MEDIUM";
  return "LOW";
}

export function getPaymentWatchdogFollowUpKey(clientId, settlementMonth) {
  return `${clientId}#${settlementMonth}`;
}

export function getDueDateForSettlementMonth(settlementMonth) {
  const [year, month] = settlementMonth.split("-").map(Number);
  const dueDate = new Date(Date.UTC(year, month, 10));
  return [
    dueDate.getUTCFullYear(),
    padDatePart(dueDate.getUTCMonth() + 1),
    padDatePart(dueDate.getUTCDate()),
  ].join("-");
}

export function enrichSettlementsWithWatchdog({ settlements = [], followUps = {}, now = new Date() } = {}) {
  return settlements.map((settlement) => {
    const balance = getSettlementBalance(settlement);
    const isDebtCase = balance < 0;
    const amountDue = isDebtCase ? Math.abs(balance) : 0;
    const settlementMonth = getSettlementMonth(settlement);
    const dueDate = isDebtCase ? getDueDateForSettlementMonth(settlementMonth) : null;
    const overdueDays = isDebtCase ? Math.max(0, Math.floor((getUtcDateOnly(now) - getUtcDateOnly(dueDate)) / DAY_IN_MS)) : 0;
    const followUpKey = getPaymentWatchdogFollowUpKey(settlement.clientId, settlementMonth);
    const followUp = followUps[followUpKey] || {};

    return {
      ...settlement,
      watchdog: {
        isDebtCase,
        amountDue,
        dueDate,
        overdueDays,
        priority: getPriority({
          isDebtCase,
          amountDue,
          overdueDays,
          approved: settlement.approved,
        }),
        followUpStatus: followUp.status || PAYMENT_WATCHDOG_FOLLOW_UP_STATUSES.TO_CONTACT,
        followUpNote: followUp.note || "",
        followUpHistory: followUp.history || [],
        followUpUpdatedAt: followUp.updatedAt || null,
      },
    };
  });
}

export function filterWatchdogSettlements(settlements = [], filters = {}) {
  const minAmount = Number(filters.minAmount) || 0;
  const minOverdueDays = Number(filters.minOverdueDays) || 0;

  return settlements
    .filter(settlement => !filters.enabledOnly || (settlement.watchdog && settlement.watchdog.isDebtCase))
    .filter(settlement => minAmount === 0 || (settlement.watchdog && settlement.watchdog.amountDue >= minAmount))
    .filter(settlement => minOverdueDays === 0 || (settlement.watchdog && settlement.watchdog.overdueDays >= minOverdueDays))
    .filter(settlement => !filters.priority || (settlement.watchdog && settlement.watchdog.priority === filters.priority))
    .filter(settlement => !filters.followUpStatus ||
      (settlement.watchdog && settlement.watchdog.followUpStatus === filters.followUpStatus));
}
